import { render, staticRenderFns } from "./pills.vue?vue&type=template&id=a49d7ff6&lang=html&"
import script from "./pills.vue?vue&type=script&lang=js&"
export * from "./pills.vue?vue&type=script&lang=js&"
import style0 from "./pills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../base-image/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports